import React from 'react';
import { WDHImage } from '@demant/wdh';
import { withReactBootstrap } from '@demant/wdh-react-bootstrap';
var BlogAuthorDetailsApp = function BlogAuthorDetailsApp(_ref) {
  var settings = _ref.settings;
  var getImage = function getImage() {
    var imageData = settings.authorImage;
    return /*#__PURE__*/React.createElement(WDHImage, {
      image: imageData.image
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "author-details-component"
  }, /*#__PURE__*/React.createElement("div", {
    className: "author-image"
  }, getImage()), /*#__PURE__*/React.createElement("div", {
    className: "author-intro"
  }, /*#__PURE__*/React.createElement("div", {
    className: "author-headline"
  }, /*#__PURE__*/React.createElement("h2", null, settings.authorHeadline.text)), /*#__PURE__*/React.createElement("div", {
    className: "author-quote"
  }, settings.authorQuote.text))));
};
export default withReactBootstrap(BlogAuthorDetailsApp);